<template>
  <section class="app-main">
<!--       <router-view :key="key"></router-view>-->
      <router-view />
<!--      <transition name="fade" mode="out-in">-->
<!--        <keep-alive>-->
<!--          <router-view v-if="$route.meta && $route.meta.keepAlive" />-->
<!--        </keep-alive>-->
<!--      </transition>-->
<!--      <transition name="fade" mode="out-in">-->
<!--        <router-view v-if="!$route.meta || !$route.meta.keepAlive" />-->
<!--      </transition>-->

  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    // key() {
      // return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: content-box;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
// .el-popup-parent--hidden {
//   .fixed-header {
//     padding-right: 15px;
//   }
// }
</style>
